import {
  createInstalledAppUpdater,
  createUnsentInputTracker,
  fetchDeployedBuildId,
  getRunningBuildId,
  isRunningAsInstalledApp,
} from '@/lib/installed-app-update'
import { useEffect } from 'react'

const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'input'] as const

export function useReloadInstalledAppOnNewDeploy() {
  useEffect(() => {
    const unsentInput = createUnsentInputTracker()
    const updater = createInstalledAppUpdater({
      currentBuildId: getRunningBuildId(),
      isInstalledApp: () => isRunningAsInstalledApp(),
      now: () => Date.now(),
      fetchDeployedBuildId: () => fetchDeployedBuildId(),
      hasUnsentInput: () => unsentInput.hasUnsentInput(),
      reload: () => window.location.reload(),
    })
    const onVisibilityChange = () => {
      void updater.handleVisibility(document.visibilityState === 'hidden' ? 'hidden' : 'visible')
    }
    const onPageHide = () => {
      void updater.handleVisibility('hidden')
    }
    const onPageShow = () => {
      void updater.handleVisibility('visible')
    }
    const onInteraction = (event: Event) => {
      updater.handleInteraction()
      if (event.type === 'input')
        unsentInput.recordInput(event.target)
    }
    document.addEventListener('visibilitychange', onVisibilityChange)
    window.addEventListener('pagehide', onPageHide)
    window.addEventListener('pageshow', onPageShow)
    for (const eventName of INTERACTION_EVENTS)
      window.addEventListener(eventName, onInteraction, { capture: true, passive: true })
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
      window.removeEventListener('pagehide', onPageHide)
      window.removeEventListener('pageshow', onPageShow)
      for (const eventName of INTERACTION_EVENTS)
        window.removeEventListener(eventName, onInteraction, { capture: true })
    }
  }, [])
}
